import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const ContactDetailPage = lazy(() => import('./detail-page').then((m) => ({ default: m.ContactDetailPage })));
const ContactListPage = lazy(() => import('./list-page').then((m) => ({ default: m.ContactListPage })));

export const contactRoutes: RouteObject[] = [
  {
    path: 'contacts',
    handle: { crumb: 'Contacts' },
    children: [
      { index: true, element: <ContactListPage /> },
      { path: ':id', element: <ContactDetailPage />, handle: { crumb: (p: Record<string, string | undefined>) => p.id ?? 'Contact' } },
    ],
  },
];
